export const scbooksUrl = (path: string) => `https://www.scbooks.com.tw/#${path}`;